module.exports = {
	"articleTitle1": "Secretary of the Army Eric Fanning hosts fireside chat at Chrysler ...",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Chrysler Center",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/arts/springfest-announcement",
	"articleSnippet1": "Secretary of the Army Eric Fanning hosts fireside chat at Chrysler Center. Maya \nGoldman. Daily Staff Reporter. Wednesday, January 11, 2017 - 4:19pm ...",
	"articleSnippet2": "Mar 20, 2017 ... MUSIC Matters' SpringFest will be hosting headliners 2 Chainz, Lil Yachty and \nDesiigner at the Crisler Center for the organization's ...",
	"totalMisc": 0,
	"articleTitle2": "2 Chainz, Lil Yachty and Desiigner coming to Crisler Center for ...",
	"address": "2121 Bonisteel Blvd. Ann Arbor, MI",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/tko.NEW_.OwnIt_.11.21.13.RGB_.jpg",
			"author": "Tracy Ko",
			"caption": "Ed Seaberg, Vice President of IT Operations at Rockwell Automation, speaks at \"Leading Inclusion in Corporate America\" in the Chesebrough Auditorium at Chrysler Center Thursday."
		}
	],
	"position": {
		"lat": 42.290863,
		"lng": -83.716675
	},
	"tips": [
		{
			"text": "Second floor has some really comfy couches and is usually a better place for relaxed studying than the dude or pierpont.",
			"person": "Nick Kortman"
		}
	],
	"bathroomrating": [
		{
			"rating": 2,
			"bathroom": "1st Floor"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/chrysler.json
// module id = 850
// module chunks = 0